import React from 'react';

import { getDefault, readCMSValue } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';

import { Actualite, Promo, Introduction, Showroom } from 'modules/shared-cms-advanced/enhanced-blocs';
import { CustomerBlocContainer, RubricBloc } from 'modules/shared-cms-advanced/components';

import { DressLandingProps } from './dress-landing-type';

import enhancer from './dress-landing-enhancer';

import styles from './dress-landing-page.module.css';

const InnerDressLandingPage: React.FC<DressLandingProps> = React.memo(
    ({ intro, promo, actualite, showRoom, ...rest }: DressLandingProps) => {
        const {
            introId = getDefault(getNestedReferenceId(intro), ''),
            promoId = getDefault(getNestedReferenceId(promo), ''),
            actualiteId = getDefault(getNestedReferenceId(actualite), ''),
            showRoomId = getDefault(getNestedReferenceId(showRoom), ''),
            rubric = {
                title: getDefault(readCMSValue(rest.rubricTitle), ''),
                subtitle: getDefault(readCMSValue(rest.rubricSubtitle), ''),
                items: getDefault(readCMSValue(rest.rubricItems), []),
            },
        } = {};
        return (
            <React.Fragment>
                <div className={`${styles.root}`}>
                    {/* Introduction */}
                    {introId !== '' && <Introduction id={introId} />}

                    {(rubric.title !== '' || rubric.subtitle !== '' || rubric.items.length > 0) && (
                        <div className={styles.rubricBlock}>
                            <RubricBloc {...rest} />
                        </div>
                    )}

                    {/* Actualité */}
                    {actualiteId !== '' && (
                        <div className={`${styles.newsContainer}`}>
                            <Actualite id={actualiteId} />
                        </div>
                    )}

                    {/* Promo */}
                    {promoId !== '' && (
                        <div className={styles.promoContainer}>
                            <Promo id={promoId} />
                        </div>
                    )}

                    {/* Images Clients */}
                    <CustomerBlocContainer {...rest} />

                    {showRoomId !== '' && <Showroom id={showRoomId} />}
                </div>
            </React.Fragment>
        );
    },
);

export const DressLandingPage = enhancer(InnerDressLandingPage);
